import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormField } from 'site-modules/shared/components/form-field/form-field';
import { LoadingSpinner } from 'site-modules/shared/components/loading-spinner/loading-spinner';
import { ErrorFieldCopy } from 'site-modules/shared/components/lead-form/error-field-copy/error-field-copy';

export function CardList({
  children = null,
  className = '',
  selectedLeadIds = {},
  fieldRef,
  validationErrors = {},
  showListTargetsLoadingIndicator = false,
  ariaLabel = 'Dealer list',
  hideValidationError = false,
}) {
  const selectedLeadsEmpty = Object.keys(selectedLeadIds).length || '';
  const selectedLeadsValid = !('selectedLeadsEmpty' in validationErrors);

  return (
    <div className={className}>
      {!hideValidationError && (
        <ErrorFieldCopy
          id="error-selectedLeads"
          className={classNames('text-danger medium', { 'd-none': selectedLeadsValid })}
          copy={validationErrors.selectedLeadsEmpty}
        />
      )}
      <FormField
        hidden
        type="hidden"
        id="lead-form-selected-leads-empty"
        name="selectedLeadsEmpty"
        ref={fieldRef}
        defaultValue={selectedLeadsEmpty}
        aria-required
        aria-invalid={!selectedLeadsValid}
        aria-describedby="error-selectedLeads"
      />
      <LoadingSpinner isLoading={showListTargetsLoadingIndicator}>
        <div className={classNames({ 'has-danger': !selectedLeadsValid })}>
          <fieldset className="listbox">
            {!!ariaLabel && <legend className="visually-hidden">{ariaLabel}</legend>}
            {children}
          </fieldset>
        </div>
      </LoadingSpinner>
    </div>
  );
}

CardList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  selectedLeadIds: PropTypes.shape({}),
  fieldRef: PropTypes.func.isRequired,
  validationErrors: PropTypes.shape({}),
  showListTargetsLoadingIndicator: PropTypes.bool,
  hideValidationError: PropTypes.bool,
  ariaLabel: PropTypes.string,
};
